<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.storeName"
              placeholder="请输入店名"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.certificateNo"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.level"
              placeholder="请输入档位"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px; padding: 0 2px;"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @batchImport="batchImportFun"
        @dblclick="viewFun(arguments)"
        @view="viewFun(arguments)"
        @delete="deleteFun(arguments)"
        @batchDelete="batchDeleteFun"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 批量导入数据 组件 -->
    <import-dialog
      :dialog-visible.sync="dialogImportVisible"
      :dialog-import-title="dialogImportTitle"
      @reloadData="loadTableData()"
    />

    <!-- 批量作废 组件 -->
    <el-dialog
      v-if="dialogBatchDeleteVisible"
      title="批量作废高价值零售户"
      :visible.sync="dialogBatchDeleteVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleBatchDeleteClose"
      destroy-on-close
      append-to-body
      class="abow_dialog h220_dialog"
      width="360px"
    >
      <el-form
        ref="dialogBatchDeleteForm"
        :model="dialogBatchDeleteForm"
        :rules="dialogBatchDeleteFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="版本号"
              prop="versionCode"
            >
              <el-input
                v-model="dialogBatchDeleteForm.versionCode"
                clearable
                autofocus
                maxlength="24"
                placeholder="请输入要删除的高价值零售户版本号"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleBatchDeleteClose">
          关闭
        </el-button>
        <el-button
          type="primary"
          @click="handleBatchDeleteSave"
        >
          作废
        </el-button>
      </div>
    </el-dialog>

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-title="dialogViewTitle"
      :dialog-visible.sync="dialogViewVisible"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 查看
import viewDialog from './components/viewDialog'
// 批量导入数据 组件
import importDialog from './components/importDialog'
// API
import { loadHighValueStoreListDataApi, exportHighValueStoreListDataApi, deleteHighValueStoreApi, deleteBatchHighValueStoreApi } from '@/api/v2/highValueStore';

export default {
  name: 'HighValueStoreView',
  components: {
    CustomTable2,
    TableOperation2,
    viewDialog,
    importDialog,
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'high_value_store_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['high_value_store_import'],
            prop: 'batchImport',
            label: '批量导入',
            method: 'batchImport'
          },
          {
            permissionSigns: ['high_value_store_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['high_value_store_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['high_value_store_del'],
            prop: 'batchDelete',
            label: '批量作废',
            method: 'batchDelete'
          },
          {
            permissionSigns: ['high_value_store_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          },
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          certificateNo: '',
          storeName: '',
          level: ''
        }
      },
      id: null,
      eventType: '',
      // 查看
      dialogViewTitle: '查看',
      dialogViewVisible: false,
      // 批量导入
      dialogImportVisible: false,
      dialogImportTitle: '导入高价值零售户档案',
      // 批量作废
      dialogBatchDeleteVisible: false,
      dialogBatchDeleteForm: {
        versionCode: ''
      },
      dialogBatchDeleteFormRules: {
        versionCode: [{ required: true, message: '请输入要删除的高价值零售户版本号', trigger: 'blur' }],
      }
    }
  },
  created () {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 120 },
      { prop: 'cityName', label: '城市', filterColumn: 'city_name', width: 120 },
      { prop: 'certificateNo', label: '专卖证号', filterColumn: 'certificate_no', width: 120 },
      { prop: 'storeName', label: '零售户名称', filterColumn: 'store_name', width: 200 },
      { prop: 'level', label: '档位', filterColumn: 'level', width: 80 },
      { prop: 'marketType', label: '市场类型', filterColumn: 'market_type', width: 120 },
      { prop: 'businessType', label: '业态', filterColumn: 'business_type', width: 100 },
      { prop: 'businessCapacity', label: '经营能力', filterColumn: 'business_capacity', width: 120 },
      { prop: 'contributeCapacity', label: '贡献能力', filterColumn: 'contribute_capacity', width: 120 },
      { prop: 'developmentPotential', label: '发展潜力', filterColumn: 'development_potential', width: 120 },
      { prop: 'versionCode', label: '版本号', filterColumn: 'version_code', width: 90 },
      { prop: 'operatorName', label: '操作人', filterColumn: 'operator_name', width: 120 },
      { prop: 'operationTime', label: '操作时间', filterColumn: 'operation_time', width: 150, isBetween: true },
    ]

    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadHighValueStoreListDataApi(_this.masterList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 批量导入
    batchImportFun () {
      let _this = this;
      _this.dialogImportVisible = !_this.dialogImportVisible
    },
    // 查看
    viewFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的高价值零售户', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 作废
    deleteFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要作废的高价值零售户', type: 'warning' })
        return
      }
      _this.$confirm('是否确定作废该高价值零售户信息？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        deleteHighValueStoreApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '作废成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 批量作废
    batchDeleteFun () {
      let _this = this;
      _this.dialogBatchDeleteForm = {
        versionCode: ''
      }
      _this.dialogBatchDeleteVisible = !_this.dialogBatchDeleteVisible;
      _this.$nextTick(() => {
        _this.$refs.dialogBatchDeleteForm.clearValidate();
      });
    },
    // 批量作废弹窗关闭
    handleBatchDeleteClose () {
      let _this = this;
      _this.dialogBatchDeleteVisible = !_this.dialogBatchDeleteVisible;
      _this.$refs.dialogBatchDeleteForm.clearValidate();
    },
    // 批量作废保存
    handleBatchDeleteSave () {
      let _this = this;
      _this.$refs.dialogBatchDeleteForm.validate(valid => {
        if (valid) {
          let _this = this;
          _this.$confirm("确认批量作废, 是否继续?", "系统提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", center: true }).then(() => {
            deleteBatchHighValueStoreApi(_this.dialogBatchDeleteForm).then(() => {
              _this.$message({ type: "success", message: "批量作废成功" });
              _this.dialogBatchDeleteVisible = !_this.dialogBatchDeleteVisible;
              _this.loadTableData();
            }
            );
          }).catch(() => { });
        } else {
          return false;
        }
      });
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportHighValueStoreListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
